
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { SparkLinkedService } from 'app/model/linkedservice/spark.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'SparkObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Spark_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Spark_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SparkLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SparkObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
